import { render, staticRenderFns } from "./CourseCategoryManagement.vue?vue&type=template&id=23f11d7c&scoped=true"
import script from "./CourseCategoryManagement.vue?vue&type=script&lang=js"
export * from "./CourseCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./CourseCategoryManagement.vue?vue&type=style&index=0&id=23f11d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f11d7c",
  null
  
)

export default component.exports